module.exports = __webpack_public_path__ + "static/media/author4.7fc72d5f.jpg";